import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import removeTags from 'utils/removetags'
import config from 'config'
import { connect } from 'react-redux'

const propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  jobUrlSlug: PropTypes.string,
  photo: PropTypes.string,
}

const defaultProps = {
  title: '',
  jobUrlSlug: '',
  photo: '',
  description: '',
}

export function MetaTags({ title, description, jobUrlSlug, photo }) {
  return (
    <Helmet>
      {title ? (
        <title>{`${title} - Recright.com`}</title>
      ) : (
        <title>Recright.com</title>
      )}
      <meta name="twitter:card" content="summary_large_image" />

      <meta property="og:title" content={title.substring(0, 200)} />
      <meta name="twitter:title" content={title.substring(0, 200)} />

      <meta name="description" content={removeTags(description)} />
      <meta property="og:description" content={removeTags(description)} />
      <meta name="twitter:description" content={removeTags(description)} />

      <link rel="canonical" href={`${config.BASE_URL}/${jobUrlSlug}`} />
      <meta property="og:url" content={`${config.BASE_URL}/${jobUrlSlug}`} />
      <meta name="twitter:url" content={`${config.BASE_URL}/${jobUrlSlug}`} />

      <meta property="og:image" content={photo} />
      <meta name="twitter:image" content={photo} />
    </Helmet>
  )
}

MetaTags.propTypes = propTypes
MetaTags.defaultProps = defaultProps

export default connect()(MetaTags)
